<!--
* 组件名 : 第三章节子章节首页
* 开发者 : JY
*
* 参数:
*   pageData         { Object } -  章节首页数据
* 事件: null
*
-->

<template>
  <div class="v-sub-chapter-index-page content-box">
    <div class="sub-chapter-head">
      <p class="chapter-label title1">{{ pageData.number }}</p>
      <h4 class="stage-title title1 parent-title" v-if="pageData.parentTitle">
        {{ pageData.parentTitle }}
      </h4>
      <h2
        class="stage-title title1 second-title"
        v-html="pageData.secondTitle"
      />
      <p class="stage-year num">{{ pageData.period }}</p>
    </div>
    <div class="chapter-info set-font-size" v-html="pageData.content" />
  </div>
</template>

<script>
export default {
  name: "v-sub-chapter-index-page",
  props: {
    pageData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.v-sub-chapter-index-page {
  transform: translateZ(0);
  padding: 126px 0 172px 0;

  .sub-chapter-head {
    .stage-year {
      margin-bottom: 32px;
    }

    .chapter-label {
      margin-bottom: 16px;
    }

    .second-title {
      margin-bottom: 24px;
    }
  }

  .chapter-info {
    p,
    span,
    strong {
      font-size: var(--font-size);
      line-height: 1.9;
    }
  }
}

body[data-lang="zh-TW"],
body[data-lang="zh-CN"] {
  .v-sub-chapter-index-page {
    .chapter-info {
      p {
        text-indent: 2em;
        margin-bottom: 16px;
      }
    }
  }
}
</style>
